import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';

type Props = {
  classes: Object,
  visible?: boolean,
  dark?: boolean,
};

const defaultProps = {
  visibile: false,
};

function FriendDisabledOverlay({
  classes,
  visible,
  dark,
}: Props) {
  return (
    <div className={classNames(classes.disabled, { visible, dark })} />
  );
}

FriendDisabledOverlay.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    disabled: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      opacity: 0,
      pointerEvents: 'none',
      transition: 'opacity 0.2s linear',
      backgroundColor: theme.color.basis6,
      zIndex: 1,
      '&.visible': {
        '&.dark': {
          opacity: 0.9,
        },
        '&:not(.dark)': {
          opacity: 0.5,
        },
        pointerEvents: 'auto',
      },
    },
  };
}

export default useSheet(applyStyles)(FriendDisabledOverlay);
